export default {
    AsterList: {
        getdata: []
    }
};